<template>
  <div :class="{ hide: !showLoader }" class="level">
    <div class="level-item">
      <div v-if="type === 'cube'" class="sk-cube-grid">
        <div class="sk-cube sk-cube1"></div>
        <div class="sk-cube sk-cube2"></div>
        <div class="sk-cube sk-cube3"></div>
        <div class="sk-cube sk-cube4"></div>
        <div class="sk-cube sk-cube5"></div>
        <div class="sk-cube sk-cube6"></div>
        <div class="sk-cube sk-cube7"></div>
        <div class="sk-cube sk-cube8"></div>
        <div class="sk-cube sk-cube9"></div>
      </div>
      <div v-else class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <p><slot></slot></p>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    showLoader: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'circle',
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/scss/loader.scss';

.global-loader {
  p {
    margin-right: 10px;
  }
}

.hide {
  display: none;
}

.level {
  margin: 0;
}
</style>
